<template>
  <div class="shipments-page">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <h2>{{$t('Delivery Orders')}}</h2>
      </div>
      <div class="vx-col w-full lg:w-1/2 items-end">
        <shipment :type="type" :shipmentModal="shipmentModal" @shipmentModal="shipmentModal = $event" @loadShipments="loadShipments"></shipment>
      </div>
    </div>
    <head-component
      :noActions="true"
      v-intro-autostart="!tourMerchantOrders"
      v-intro-autostart:on.exit="onTourComplete"
      v-intro-autostart:on.complete="onTourComplete"
      v-intro-step="1"
      v-intro="$t('You can select status then will appear all delivery orders belongs to this status')"
      v-intro-autostart.config="{ nextLabel: $t('Next'), prevLabel: $t('Back'), doneLabel: $t('Done!') }"
      :statusFilters="statusFilters"
      :selected="selected" @changeFilter="changeFilter" @loadShipments="loadShipments" @filterValue="filterValue = $event">
    </head-component>

    <div class="xl:float-left clearfix xl:w-3/5 mt-4 w-full">
      <export-button class="mr-4 float-left whitespace-nowrap"></export-button>
      <download-button class="mr-4 float-left whitespace-nowrap" :selected="selected"></download-button>
      <request-button class="mr-4 float-left whitespace-nowrap" :selected="selected" @selected="selected = $event" @loadShipments="loadShipments"></request-button>
      <cancel-shipments-button class="mr-4 float-left whitespace-nowrap" :selected="selected" @selected="selected = $event" @loadShipments="loadShipments"></cancel-shipments-button>
      <print-label-button class="mr-4 float-left whitespace-nowrap" :selected="selected"></print-label-button>
      <restart-orders class="mr-4 float-left whitespace-nowrap" :selected="selected" @loadShipments="loadShipments"></restart-orders>
      <exchange-order class="mr-4 float-left whitespace-nowrap" :selected="selected" @returnPackages="returnPackages('Exchange Packages', selected[0])"></exchange-order>
    </div>
    <shipblu-table
     :sst="true"
     orders
      multiple
      v-model="selected"
      :max-items="maximumItems"
      @searchDate="handleSearchDate"
      @search="handleSearch"
      @keyup.enter.native="handleSearch"
      searchDate
      search
      pagination
      :data="shipments"
      :tableLoader="tableLoader"
    >

      <template slot="thead">
        <shipblu-th v-intro="$t('Tracking Number')" v-intro-step="2">{{$t('Tracking No.')}}</shipblu-th>
        <shipblu-th v-intro="$t('Date of adding order on ShipBlu')" v-intro-step="3">{{$t('Created On')}}</shipblu-th>
        <shipblu-th v-intro="$t('Customer\'s Name')" v-intro-step="4">{{$t('Customer Info')}}</shipblu-th>
        <shipblu-th v-intro="$t('Customer\'s Address')" v-intro-step="5">{{$t('Location')}}</shipblu-th>
        <shipblu-th v-intro="$t('Customer\'s Phone')" v-intro-step="6">{{$t('Phone')}}</shipblu-th>
        <shipblu-th v-intro="$t('Number of pieces or packages sent to the customer')" v-intro-step="7">{{$t('Packages')}}</shipblu-th>
        <shipblu-th v-intro="$t('Total amount to be collected')" v-intro-step="8">{{$t('CoD')}}</shipblu-th>
        <shipblu-th v-intro="$t('Date of receiving order')" v-intro-step="9">{{$t('Pickup Date')}}</shipblu-th>
        <shipblu-th v-intro="$t('Order status')" v-intro-step="10">{{$t('Status')}}</shipblu-th>
        <shipblu-th v-intro="$t('Order arrival time')"  v-intro-step="11">{{$t('Delivered On')}}</shipblu-th>
        <shipblu-th v-intro="$t('Options to view all shipment data')"
          v-intro-step="12"
          v-if="(!$route.params.merchantID && !$route.params.warehouseID) || $store.state.AppActiveUser.userRole === 'customer-support'">{{$t('Actions')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="`${getStyle(data[indextr])}`"
          :to="{ name: `${$store.state.AppActiveUser.userRole}-delivery-orders`, params: { type: 'delivery-orders', orderID: data[indextr].id }}">
          <shipblu-td :data="data[indextr].trackingNumber" class="inactive-link">
            <p v-on:click.stop>{{ data[indextr].tracking_number }}</p>
            <div v-if="data[indextr].fulfillment_provider_metadata" class="inline-flex items-center">
              <p class="text-warning"><feather-icon icon="PackageIcon" class="w-4"/></p>
              <p class="text-xs text-warning font-medium px-1">{{$t('FulFillment')}}</p>
            </div>
          </shipblu-td>

          <shipblu-td :data="data[indextr].createdOn">
            {{ common.splitYearOfDate(data[indextr].created) }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].customerInfo">
            {{ data[indextr].customer.full_name }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].location">
            {{ $t(data[indextr].customer.address.zone.name) }} / {{ $t(data[indextr].customer.address.zone.city.name) }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].phone">
            {{ data[indextr].customer.phone }}
          </shipblu-td>
          <shipblu-td :data="data[indextr].packages">
            {{ data[indextr].packages.length }}
          </shipblu-td>
          <shipblu-td :data="data[indextr].cashOnDelivery">
            {{ data[indextr].cash_amount && parseInt(data[indextr].cash_amount) > 0 ? ((Number(data[indextr].cash_amount)).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'N/A' }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].pickupDate">
            {{ data[indextr].pickup_date? data[indextr].pickup_date.split('T')[0] : '' }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].status" :style="`color: ${getStyle(data[indextr])}`" style="white-space: nowrap;">
            <template v-if="checkTooltip(data[indextr])">
              <vx-tooltip :text="data[indextr].failure_data.map(element => element.question === 'Choose reason for failed delivery'  ? element.created.split('T')[0] + '\n' + element.answer  : '').filter(element => element !== '').join('\n \n')">
                <div class="m-auto flex items-center justify-center font-semibold">
                  <div><span class="status-icon mr-1"></span></div>
                  <span class="capitalize">{{ $t(getStatusLabel(data[indextr])) }}</span>
                </div>
              </vx-tooltip>
            </template>
            <template v-else>
              <div class="m-auto flex items-center justify-center font-semibold">
                <div><span class="status-icon mr-1"></span></div>
                <span class="capitalize">{{ $t(getStatusLabel(data[indextr])) }}</span>
              </div>
            </template>
          </shipblu-td>

          <shipblu-td :data="data[indextr].deliveredOn">
            {{ data[indextr].delivered_date && data[indextr].status === 'delivered' ? data[indextr].delivered_date.split('T')[0] : '' }}
          </shipblu-td>

          <shipblu-td v-if="(!$route.params.merchantID && !$route.params.warehouseID) || $store.state.AppActiveUser.userRole === 'customer-support'">
            <div @click="removeAttribute($event)">
              <vs-dropdown
                vs-trigger-click
                @click="selected = []"
                class="dd-actions cursor-pointer"
              >
                <vs-button
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-more-horizontal"
                  class="mr-2"
                >
                </vs-button>
                <vs-dropdown-menu style="width: 190px">
                  <vs-dropdown-item
                    @click="viewShipment(data[indextr])"
                  >
                    <span class="flex items-center">
                      <feather-icon
                        icon="EyeIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('View')}}</span>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="$store.state.AppActiveUser.userRole === 'merchant' && Number(data[indextr].delivery_attempts) > 0 && data[indextr].status !== 'delivered'"
                    @click="failureReasons(data[indextr])">
                    <span class="flex items-center">
                      <feather-icon
                        icon="ListIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('Failure Reasons')}}</span>
                    </span>
                  </vs-dropdown-item>
                  <div v-if="$store.state.AppActiveUser.userRole !== 'customer-support'">
                    <!-- ACTIONS FOR ON CREATED -->
                    <vs-dropdown-item v-if="(data[indextr].status === 'created' || data[indextr].status === 'pickup_rescheduled') && !data[indextr].fulfillment_provider_metadata && !data[indextr].is_counter_dropoff && merchantStatus == 'active'"
                        @click="confirmUpdateShipmentStatus(data[indextr], 'pickup_requested')">
                        <span class="flex items-center">
                          <feather-icon
                            icon="TruckIcon"
                            svgClasses="h-4 w-4"
                            class="mr-2"
                          />
                          <span>{{$t('Request Pickup')}}</span>
                        </span>
                    </vs-dropdown-item>

                    <!-- ALLOW CANCEL IF NOT DELIVERED OR RETURNED -->
                    <vs-dropdown-item v-if="(data[indextr].status === 'created' || data[indextr].status === 'pickup_requested') && !data[indextr].fulfillment_provider_metadata && merchantStatus == 'active'"
                      @click="updateShipmentStatus(data[indextr],'cancel this order?', 'cancelled')">
                      <span class="flex items-center">
                        <feather-icon
                          icon="XCircleIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <span>{{$t('Cancel Shipment')}}</span>
                      </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="(data[indextr].status === 'picked_up' || data[indextr].status === 'in_transit' || data[indextr].status === 'out_for_delivery' || data[indextr].status === 'delivery_attempted') && merchantStatus == 'active'"
                      @click="updateShipmentStatus(data[indextr], 'return this order to origin?', 'return_to_origin')"
                    >
                      <span class="flex items-center">
                        <feather-icon
                          icon="XCircleIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <span>{{$t('Return to Origin')}}</span>
                      </span>
                    </vs-dropdown-item>
                    <!-- ACTIONS FOR DELIVERED -->
                    <vs-dropdown-item v-if="data[indextr].status === 'delivered' && merchantStatus == 'active'"
                      @click="returnPackages('Return Packages',data[indextr])">
                      <span class="flex items-center">
                        <feather-icon
                          icon="DeleteIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <span>{{$t('Pickup to Return')}}</span>
                      </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item  v-if="data[indextr].status === 'delivered' && merchantStatus == 'active'"
                      @click="returnPackages('Exchange Packages', data[indextr])">
                      <span class="flex items-center">
                        <feather-icon
                          icon="Minimize2Icon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <span>{{$t('Pickup to Exchange')}}</span>
                      </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="data[indextr].status === 'delivered'" @click="getInvoice(data[indextr])">
                      <span class="flex items-center">
                        <feather-icon
                          icon="DownloadIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <span>{{$t('Download Invoice')}}</span>
                      </span>
                    </vs-dropdown-item>
                    <!-- ACTIONS FOR CANCELLED -->
                    <vs-dropdown-item v-if="(data[indextr].status === 'cancelled') && merchantStatus == 'active'" 
                    @click="restartOrders(data[indextr])" >
                      <span class="flex items-center">
                        <feather-icon
                          icon="RotateCcwIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                        />
                        <span>{{$t('Restart Shipment')}}</span>
                      </span>
                    </vs-dropdown-item>
                  </div>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <div class="clearfix flex justify-end">
      <div class="sm:flex block items-center relative float-left mt-6">
        <button class="actions-dropdown relative mr-4">
          <div class="m-auto flex text-base items-center justify-between actions-btn">
            <span class="mr-2" id="pageSpan">{{maximumItems + ' / page'}}</span>
            <feather-icon id="pageIcon" class="w-5 h-5" icon="ChevronDownIcon"></feather-icon>
          </div>
          <div class="dropdown-list hidden-list" id="paginationList">
            <button @click="changePageSize(item)" v-for="item in pageSizes" :key="item.index">
              <span>{{ item }}</span>
            </button>
          </div>
        </button>
        <vs-pagination :total="Math.ceil(totalRows * 1.0 / maximumItems)" v-model="currentPage"></vs-pagination>
      </div>
    </div>
    <print type="Delivery" :selected="selected"></print>
    <div :class="$route.query.from ? 'block' : 'hidden'">
      <div :class="$route.query.from ? 'exchange-modal rounded-md' : ''">
        <div class="title py-4 flex">
          <img class="ml-6 mr-2" src="../../assets/images/pages/Group.svg"/>
          <p class="text-primary text-base font-medium">{{ $t('Exchange Request') }}</p>
        </div>
        <p class="py-4 px-6 text-base font-medium">{{ $t('Select the delivered order you want, and pickup to exchange!') }}</p>
      </div>
      <div :class="$route.query.from ? 'show-exchange-modal' : ''"></div>
    </div>
    <!-- MODAL FOR FAILURE REASONS -->
    <shipblu-prompt
      class="shipment-modal"
      @close="closeModal"
      :active.sync="reasonsFlag"
      :title="$t('Failure Reasons')"
      :buttons-hidden="true">
        <div class=" ml-6" v-if="reasons.failure_data">
          <div class="flex font-semibold text-lg" v-for="answer in reasons.failure_data" :key="answer.index">
            <p class="font-bold" v-if="answer.question === 'Choose reason for failed delivery'">{{answer.created.split('T')[0] + ' ' + answer.created.split('T')[1].split('.')[0]}}</p>
            <p class="ml-6 mb-2" v-if="answer.question === 'Choose reason for failed delivery'">{{ $t(answer.answer) }}</p>
          </div>
        </div>
    </shipblu-prompt>
    <return-and-exchange-package :userMerchant="userMerchant" :title="title" :governorateId="governorateId" :merchant="merchant" :returnPackagesFlag="returnPackagesFlag" :returnPackagesData="returnPackagesData"
      @returnPackagesFlag="returnPackagesFlag = $event" @loadShipments="loadShipments"></return-and-exchange-package>
  </div>
</template>

<script>
import {sendRequest} from '../../http/axios/requestHelper.js'
import Shipment from './components/Shipment.vue'
import Print from './components/PrintLabels.vue'
import HeadComponent from './components/Header.vue'
import i18nData from '../../i18n/i18nData.js'
import vSelect from 'vue-select'
import common  from '@/assets/utils/common'
import ReturnAndExchangePackage from './components/ReturnAndExchangePackage.vue'
import ShipbluTable from '../../layouts/components/ShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ExportButton from '../headOfFleet/components/ExportButton.vue'
import PrintLabelButton from '../headOfFleet/components/PrintLabelButton.vue'
import CancelShipmentsButton from '../admin/components/CancelShipmentsButton.vue'
import DownloadButton from '../admin/components/DownloadButton.vue'
import RequestButton from './components/RequestButton.vue'
import ShipbluPrompt from '../../layouts/components/ShipBluPrompt.vue'
import RestartOrders from './components/RestartButton.vue'
import ExchangeOrder from './components/ExchangeOrder.vue'

export default {
  data () {
    return {
      pageSizes: [25, 50, 100],
      common,
      merchantUID: this.$store.state.AppActiveUser.uid,
      type: 'Add',
      shipmentModal: false,
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      shipmentURL: 'api/v1/delivery-orders/',
      selected: [],
      tableList: [
        'shipblu-th: Component',
        'shipblu-tr: Component',
        'shipblu-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      shipments: [],
      statusFilters: [
        {
          name: 'all',
          value: 'all',
          color: ''
        },
        {
          name: 'created',
          value: 'created',
          color: 'bg-dark'
        },
        {
          name: 'pickup requested',
          value: 'pickup_requested',
          color: 'bg-warning'
        },
        {
          name: 'picked up',
          value: 'picked_up',
          color: 'bg-primary'
        },
        {
          name: 'in transit',
          value: 'in_transit',
          color: 'bg-primary'
        },
        {
          name: 'out for delivery',
          value: 'out_for_delivery',
          color: 'bg-warning'
        },
        {
          name: 'RTO requested',
          value: 'rto_requested',
          color: 'bg-warning'
        },
        {
          name: 'delivery attempted',
          value: 'delivery_attempted',
          color: 'bg-danger'
        },
        {
          name: 'delivered',
          value: 'delivered'
        },
        {
          name: 'fulfillment',
          value: 'fulfillment'
        }
      ],
      filters: [],
      merchant: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      searchVal: this.$route.query.search ? this.$route.query.search : '',
      offset: 0,
      shipment: {},
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      merchantID: '',
      merchantStatus: '',
      title: '',
      returnPackagesFlag: false,
      returnPackagesData: {},
      reasonsFlag: false,
      reasons: {},
      file_URl: '',
      trackingData: {},
      trackingStatus: '',
      tourMerchantOrders: '',
      governorateId: '',
      searchInProgress: false,
      searchedValue: ' ',
      fromDate: '',
      toDate: '',
      criteria: '',
      userMerchant: {},
      tableLoader: false
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      if (this.$route.params.warehouseID) {
        this.loadWarehouseShipments()
      } else {
        this.$router.push({
          name: 'merchant-shipments',
          query: {
            filter: this.filters,
            page: this.currentPage
          }
        }).catch(() => {})
        this.loadShipments()
      }
    },
    '$route.query.filter' () {
      if (this.$route.params.warehouseID && !this.$route.params.merchantID && !this.$route.query.filter) {
        this.filters = []
        this.loadWarehouseShipments()
      } else if (!this.$route.query.filter) {
        this.filters = []
        this.loadShipments()
      } else if (this.$route.query.from) {
        this.filters = this.$route.query.filter
        this.loadShipments()
      }
    },
    'searchVal' () {
      this.$router.push({
        query: {
          search: this.searchVal,
          page: this.currentPage,
          filter: this.filters
        }
      }).catch(() => {})
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    changePageSize (val) {
      localStorage.setItem('maxItems', val)
      this.maximumItems = val
      this.currentPage = 1
      if (this.$route.params.warehouseID) {
        this.loadWarehouseShipments()
      } else {
        this.loadShipments()
      }
    },
    restartOrders (data) {
      const orders = []
      orders.push(data.id)
      sendRequest(false, false, this, 'api/v1/orders/restart-cancelled/', 'post', {orders_id: orders}, true,
        () => {
          this.loadShipments()
        }
      )
    },
    removeAttribute (event) {
      event.preventDefault()
    },
    checkTooltip (order) {
      return common.checkTooltip(order)
    },
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    },
    onTourComplete () {
      this.$cookies.set('tourMerchantOrders', true, '100y')
      this.$cookies.set('reloaded', true, '100y')
    },
    loadWarehouseShipments () {
      this.searchInProgress = true
      const query = `?current_warehouse=${this.$route.params.warehouseID}&offset=${this.offset}&limit=${this.maximumItems}&search=${this.searchVal}&${this.filters.includes('rto_requested') ? 'rto_requested=true' : `status=${this.filters}`}&${this.criteria}_after=${this.fromDate ? this.fromDate : ''}&${this.criteria}_before=${this.toDate ? this.toDate : ''}`
      sendRequest(false, false, this, `${this.shipmentURL}${query}`, 'get', null, true,
        (response) => {
          this.shipments = response.data.results
          this.totalRows = response.data.count
          this.searchedValue = this.searchVal
        }
      )
      this.searchInProgress = false
    },
    handleSearchDate (start, end, criteria) {
      this.fromDate = start ? new Date(start).toISOString().split('T')[0] : ''
      this.toDate = end ? new Date(end).toISOString().split('T')[0] : ''
      this.criteria = criteria
      this.$route.params.warehouseID ? this.loadWarehouseShipments() : this.loadShipments()
    },
    handleSearch (search) {
      this.offset = 0
      this.currentPage = 1
      this.searchVal = search.target ? search.target.value : search
      return common.manageSearch(search, this.loadOrdersSearch)
    },
    loadOrdersSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchVal) {
        return
      }
      this.$route.params.warehouseID ? this.loadWarehouseShipments() : this.loadShipments()
    },
    loadShipments () {
      this.tableLoader = true
      this.searchInProgress = true
      const query = `?offset=${this.offset}&limit=${this.maximumItems}&search=${this.searchVal}&${Array.isArray(this.filters) && this.filters.includes('rto_requested') ? 'rto_requested=true' : `status=${Array.isArray(this.filters) ? this.filters.filter(item => item !== 'fulfillment') : ''}`}&${this.criteria}_after=${this.fromDate ? this.fromDate : ''}&${this.filters.includes('fulfillment') ? 'fulfillment=shipblu' : ''}&${this.criteria}_after=${this.fromDate ? this.fromDate : ''}&${this.criteria}_before=${this.toDate ? this.toDate : ''}`
      sendRequest(true, false, this, `api/v1/delivery-orders/${query}`, 'get', null, true,
        (response) => {
          this.shipments = response.data.results
          this.totalRows = response.data.count
          this.searchedValue = this.searchVal
          this.tableLoader = false
        }
      )
      this.searchInProgress = false 
    },
    loadMerchant () {
      sendRequest(false, false, this, `api/v1/users/merchants/${this.merchantUID}/`, 'get', null, true,
        (response) => {
          localStorage.setItem('userMerchant', JSON.stringify(response.data))
          this.merchantID = response.data.merchant
          this.userMerchant = response.data
          this.loadMerchantData()
        }
      )
    },
    loadMerchantData () {
      sendRequest(false, false, this, `api/v1/merchants/${this.merchantID}/`, 'get', null, true,
        (response) => {
          localStorage.setItem('merchant', JSON.stringify(response.data))
          this.merchantStatus = response.data.status
          this.merchant = response.data
        }
      )
    },
    failureReasons (data) {
      this.reasonsFlag = true
      this.reasons = data
    },
    returnPackages (title, data) {
      this.governorateId = data.customer.address.zone.city.governorate.id
      this.title = title
      this.returnPackagesFlag = true
      this.returnPackagesData = {
        ...data,
        declared_value: 0
      }
    },
    changeFilter () {
      const filtersTemp = this.filters
      this.filters = []
      filtersTemp.forEach(item => {
        this.filters.push(item)
      })
      this.filters.includes(this.filterValue) ? this.filters.splice(this.filters.indexOf(this.filterValue), 1) : this.filters.push(this.filterValue)
      if (this.filterValue === 'all') {
        this.filters = []
      }
      this.selected = []
      this.currentPage = 1
      if (!this.$route.params.merchantID && !this.$route.params.warehouseID) {
        this.$router.push({
          name: 'merchant-shipments',
          query: {
            page: this.currentPage,
            filter: this.filters
          }
        }).catch(() => {})
        this.loadShipments()
      }
    },
    viewShipment (data) {
      this.$router.push({
        name: `${this.$store.state.AppActiveUser.userRole}-delivery-orders`,
        params: {
          type: 'delivery-orders',
          orderID: data.id
        }
      }).catch(() => {})
    },
    updateShipmentStatus (data, sentence, status) {
      this.trackingData = data
      this.trackingStatus = status
      this.$vs.dialog({
        color: 'danger',
        title: i18nData[this.$i18n.locale]['Confirm'],
        text: i18nData[this.$i18n.locale]['Are you sure you want to '] + i18nData[this.$i18n.locale][sentence],
        acceptText: i18nData[this.$i18n.locale]['Yes'],
        accept: this.confirmUpdateShipmentStatus
      })
    },
    confirmUpdateShipmentStatus (data, status) {
      let trackings = []
      if (data) {
        trackings = [
          {
            order: data.id,
            status
          }
        ]
      } else {
        trackings = [
          {
            order: this.trackingData.id,
            status: this.trackingStatus
          }
        ]
      }
      sendRequest(false, false, this, 'api/v1/tracking/', 'post', trackings, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Delivery Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
            position: 'top-center'
          })
          this.loadShipments()
        }
      )
    },
    getInvoice (data) {
      sendRequest(false, false, this, `api/v1/billing/merchants/${this.merchantID}/invoices/?invoiceorder__order=${data.id}`, 'get', null, true,
        (response) => {
          if (response.data.results.length > 0) {
            this.downloadInvoice(response.data.results[0].id)
          } else {
            this.$vs.notify({
              color:'warning',
              title:i18nData[this.$i18n.locale]['Warning'],
              text:i18nData[this.$i18n.locale]['Invoice isn\'t ready'],
              position: 'top-center'
            })
          }
        }
      )
    },
    downloadInvoice (invoiceId) {
      sendRequest(false, false, this, `api/v1/billing/invoices/${invoiceId}/pdf/`, 'get', null, true,
        (response) => {
          this.file_URl = response.data.file_url
          window.open(this.file_URl, '_blank')
        }
      )
    },
    closeModal () {
      this.returnPackagesFlag = false
      this.loadShipments()
    }
  },
  components: {
    Shipment,
    Print,
    HeadComponent,
    vSelect,
    ReturnAndExchangePackage,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ExportButton,
    PrintLabelButton,
    CancelShipmentsButton,
    DownloadButton,
    RequestButton,
    ShipbluPrompt,
    ExchangeOrder,
    RestartOrders
  },
  mounted () {
    this.$emit('setAppClasses', 'shipment-page')
    if (this.$store.state.AppActiveUser.userRole === 'merchant') {
      this.tourMerchantOrders = (this.$cookies.get('tourMerchantOrders') === 'true')
    }
  },
  created () {
    this.filters = this.$route.query.filter ? typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter : []
    if (JSON.parse(localStorage.getItem('userMerchant')) === null) {
      this.loadMerchant()
    } else if (JSON.parse(localStorage.getItem('merchant') === null)) {
      const userMerchant = JSON.parse(localStorage.getItem('userMerchant'))
      this.merchantID = userMerchant.merchant
      this.userMerchant = userMerchant
      this.loadMerchantData()
    } else {
      const user = JSON.parse(localStorage.getItem('merchant'))
      this.merchantID = user.id
      this.merchantStatus = user.status
      this.merchant = user
    }
    this.$router.push({
      query: {
        filter: this.filters,
        page: Number(this.currentPage) > 0 ? this.currentPage : 1
      }
    }).catch(() => {})
    this.offset = (this.currentPage - 1) * this.maximumItems
    if (this.$cookies.get('reloaded') === 'false') {
      this.$cookies.set('reloaded', true)
      location.reload()
      if (this.tourMerchantOrders === false) {
        this.$intro().start()
      }
    }
    this.tourMerchantOrders = (this.$cookies.get('tourMerchantOrders') === 'true')
    if (this.$route.params.warehouseID) {
      this.loadWarehouseShipments()
    } else if (this.$route.query.filter) {
      this.filters = typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter
      this.loadShipments()
    } else {
      this.filters = []
      this.loadShipments()
    }
  }
}
</script>

<style scoped>
.vs-dialog {
  max-width: 530px;
}
.bg-orange{
  background: #F58231 !important;
}

</style>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
#order-label-print{
  display: none;
  visibility: hidden;
}
.con-pagination-table{
  display: none;
}
.exchange-modal {
  width: 500px;
  position: fixed;
  top: calc(50% - 58.605px);
  right: calc(50% - 250px);
  z-index: 999999;
  background: #FFFFFF;
  box-shadow: 0px 2px 16px rgba(157, 173, 194, 0.38);
  transition: all 1s ease-in-out;
  animation: hideAnimation 0s ease-in-out 4s;
  animation-fill-mode: forwards;
  p {
    color: #6C84A3;
  }
}
.show-exchange-modal {
  visibility: visible;
  opacity: 1 !important;
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(10, 50, 102, 0.24);
  backdrop-filter: blur(2px);
  opacity: 0;
  animation: hideAnimation 0s ease-in-out 4s;
  animation-fill-mode: forwards;
}
@keyframes hideAnimation {
  to {
    visibility: hidden;
    width: 0;
    height: 0;
    transition: all 1s ease-in-out;
  }
}
@media (max-width: 767px) {
  .exchange-modal {
    width: unset;
    max-width: 300px;
    right: calc(50% - 150px);
  }
}
.title {
  background: rgba(220, 238, 255, 0.5);
  border-radius: 6px 0px 0px 6px;
  color: '#1C5BFE'
}
</style>
